import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";
import { Col } from "@components/General/Grid/col.component";
import { Row } from "@components/General/Grid/row.component";

import "./resultTitle.scss";

type Props = {
    mailParams?: Record<string, string>;
    displayMailButton?: boolean;
};

const ResultTitle = ({ mailParams = {}, displayMailButton = true }: Props) => {
    const { t } = useGranite();

    const printPage = () => window.print();
    const mailPage = () => {
        const link = `Link to the calculator page: ${
            window.location + determineMailQuery()
        }`;

        window.open(`mailto:?subject=Hubo calculator&body=${link}`);
    };
    const determineMailQuery = () => {
        let query = `%3F${Object.keys(mailParams)[0]}=${
            mailParams[Object.keys(mailParams)[0]]
        }`;

        const e = Object.keys(mailParams).slice(1);
        for (let index = 0; index < e.length; index++) {
            query += `%26${e[index]}=${mailParams[e[index]]}`;
        }

        return query;
    };

    return (
        <Row id="resultTitle" className={"calculator-result-title"}>
            <Col sm={8} className={"calculator-result-title-field"}>
                <Button
                    className={"calculator-result-title-field__button"}
                    color="link"
                    type="button"
                    onClick={() => printPage()}
                >
                    <i className="la-lg las la-print mr-2"></i>
                    {t("calculator.print")}
                </Button>
                {displayMailButton && (
                    <Button
                        className={"calculator-result-title-field__button"}
                        color="link"
                        type="button"
                        onClick={() => mailPage()}
                    >
                        {t("calculator.sendEmail")}
                    </Button>
                )}
            </Col>
            <Col
                sm={{ size: 4, order: "first" }}
                // @ts-ignore
                order={"last"}
                className={"calculator-result-title-field"}
            >
                <h2 className={"calculator-result-title-field__title"}>
                    {t("calculator.result")}
                </h2>
            </Col>
        </Row>
    );
};

export default ResultTitle;
